function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");
var _ref3 = /*#__PURE__*/React.createElement("defs", null);
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "1.-Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tablet---Inzicht-stel-een-vraag",
  transform: "translate(-746.000000, -539.000000)",
  stroke: "#425CD4",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Inzicht",
  transform: "translate(672.000000, 523.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Pijl",
  transform: "translate(75.000000, 17.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,4 L14,4",
  id: "Stroke-1"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-3",
  points: "10 8 14 4 10 0"
})))));
function SvgBlueArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "10px",
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "44313874-AD85-4FB9-8FC4-21020A3A2F5F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrowRight);
export default __webpack_public_path__ + "static/media/Blue_Arrow_Right.bd3f7263239cf54856bf45cb2d31c402.svg";
export { ForwardRef as ReactComponent };